import React, { useEffect, useState, useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { ProductCard } from "../components/ProductCard";
import api from "../lib/api";

const TABS = [
  { key: "all", label: "ALL" },
  { key: "meats", label: "MEATS" },
  { key: "sausages", label: "SAUSAGES" },
  { key: "ready-meals", label: "READY MEALS" },
  { key: "rubs", label: "RUBS" },
  { key: "sauces", label: "SAUCES" },
];

const Shop = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [params, setParams] = useSearchParams();
  const active = params.get("cat") || "all";

  useEffect(() => {
    setLoading(true);
    api.get("/products").then(({ data }) => {
      setProducts(data);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, []);

  const filtered = useMemo(() => {
    if (active === "all") return products;
    return products.filter((p) => p.category === active);
  }, [products, active]);

  return (
    <div data-testid="shop-page" className="max-w-7xl mx-auto px-6 lg:px-10 py-16">
      <div className="border-b border-ink-600 pb-8 mb-10">
        <div className="text-brand font-display text-sm tracking-[0.4em] mb-2">/ SHOP THE PIT</div>
        <h1 className="font-display text-6xl sm:text-7xl text-cream leading-none">EVERYTHING SMOKED.</h1>
      </div>

      {/* Tabs */}
      <div className="flex flex-wrap gap-x-8 gap-y-3 border-b border-ink-600 mb-12">
        {TABS.map((t) => (
          <button
            key={t.key}
            data-testid={`category-filter-${t.key}`}
            onClick={() => {
              const newParams = new URLSearchParams(params);
              if (t.key === "all") newParams.delete("cat");
              else newParams.set("cat", t.key);
              setParams(newParams);
            }}
            className={`pb-3 font-display text-xl sm:text-2xl tracking-widest transition-all border-b-2 -mb-px ${
              active === t.key
                ? "text-brand border-brand"
                : "text-cream border-transparent hover:text-brand"
            }`}
          >
            {t.label}
          </button>
        ))}
      </div>

      {(() => {
        if (loading) {
          return <div className="text-center text-[#A19D94] py-20 font-display tracking-widest">LOADING...</div>;
        }
        if (filtered.length === 0) {
          return <div className="text-center text-[#A19D94] py-20 font-display tracking-widest" data-testid="shop-empty">NOTHING IN THIS PIT YET.</div>;
        }
        return (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="shop-grid">
            {filtered.map((p, i) => (
              <ProductCard key={p.id} product={p} index={i} />
            ))}
          </div>
        );
      })()}
    </div>
  );
};

export default Shop;
